import { Outlet } from "react-router-dom";
import { AuthShell, AuthBrandPanel, AuthContent } from "@/components/shell/auth-shell";
import { AuthHeader } from "@/components/shell/auth-header";
import { AuthFooter } from "@/components/shell/auth-footer";

export function AuthLayout() {
  return (
    <AuthShell>
      <AuthBrandPanel />
      <AuthContent>
        <AuthHeader />
        <main className="relative flex w-full items-center justify-center">
          <Outlet />
        </main>
        <AuthFooter />
      </AuthContent>
    </AuthShell>
  );
}
